const namespace = {
  title: "Nearby schools",
  noData: "There are no available schools nearby.",
  noFilteredData:
    "There are no nearby schools that match your current filters.",
  english: "English",
  french: "French",
  board: "School Board or District",
  headers: {
    name: "Name",
    type: "Type",
    languages: "Languages",
    levels: "Levels",
    location: "Location",
    typesFilter: "All types",
    levelsFilter: "All levels",
  },
  dataDisclaimer:
    "Schools are selected for display based on their proximity to the location. Please contact the schools directly to verify attendance zones.",
} as const;

export default namespace;
